import { CSpinner } from '@coreui/react';
import React from 'react';

interface LoaderProps {
  isLoading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <CSpinner color="primary" />
    </div>
  );
};
